import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useUnitAdd } from "hooks/citajteo/dl_unit/useUnitAdd";
import { QUERY_KEYS } from "constant/react_query";
import toast from "react-hot-toast";
import UnitForm, {
  UnitFormState,
} from "components/admin/common/dl_unit/UnitForm/UnitForm";
import { EMPTY_FORM } from "constant/dl_unit/dl_unit_form.constant";

const DlUnitNew: React.FC = () => {
  const navigate = useNavigate();
  const { unitAddMutate } = useUnitAdd({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
  });
  const {
    control,
    handleSubmit: handleFormSubmit,
    reset,
  } = useForm<UnitFormState>({ defaultValues: EMPTY_FORM });
  const [errorText, setErrorText] = useState("");

  const handleSubmit = (form: UnitFormState) => {
    setErrorText("");

    const trimmedSlug = form.slug.trim();
    if (trimmedSlug === "") {
      setErrorText("Slug ne sme biti prazan.");
      return;
    }

    const parsedNum = form.num === "" ? 0 : Number(form.num);
    if (Number.isNaN(parsedNum)) {
      setErrorText("Broj mora biti numerička vrednost.");
      return;
    }

    unitAddMutate(
      {
        slug: trimmedSlug,
        uType: form.uType.trim(),
        uDate: form.uDate ?? null,
        num: parsedNum,
        fold: "",
        fVals: form.fVals,
        scans: [],
        pdf: {},
      },
      {
        onSuccess: () => {
          toast.success("Uspešno dodavanje jedinice.");
          navigate("/admin-dashboard/dl-unit-li");
        },
        onError: (error) => {
          console.error("Error adding unit:", error);
          toast.error("Greška prilikom dodavanja jedinice.");
        },
      },
    );
  };

  const handleReset = () => {
    reset(EMPTY_FORM);
    setErrorText("");
  };

  return (
    <UnitForm
      control={control}
      errorText={errorText}
      onSubmit={handleFormSubmit(handleSubmit)}
      onReset={handleReset}
    />
  );
};

export default DlUnitNew;
